import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import TextAnswer from './TextAnswer';
import CheckAnswer from './CheckAnswer';
import SelectAnswer from './SelectAnswer';
import NumericAnswer from './NumericAnswer';
import PickList from '../../common/PickList';
import ScaleRange from '../../common/ScaleRange';
import SingleSelect from '../../common/SingleSelect';
import { QUESTION_TYPES } from '../../../constants/props';
import getScaleAnswers from '../../../utils/getScaleAnswers';

const Answers = ({ answer, question, onChange }) => {
  const type = get(question, 'settings.name');
  const { id, settings } = question || {};
  const list = get(settings, 'meta.availableAnswers');
  const tempId = `answer-${id}`;

  useEffect(() => {
    if (answer) onChange(answer);
  }, []);

  switch (type) {
    case QUESTION_TYPES.appointmentConsent: {
      return (
        <SingleSelect
          name={tempId}
          list={['No', 'Yes']}
          selectedValue={answer || null}
          onChange={value => onChange(value === 'Yes' ? 'true' : 'false')}
        />
      );
    }
    case QUESTION_TYPES.general: {
      return (
        <SelectAnswer
          tempId={tempId}
          selectedValue={answer}
          onChange={onChange}
        />
      );
    }
    case QUESTION_TYPES.consent: {
      return (
        <CheckAnswer
          settings={settings}
          selectedValue={answer}
          tempId={tempId}
          onChange={onChange}
        />
      );
    }
    case QUESTION_TYPES.numeric:
      return (
        <NumericAnswer
          {...{ tempId }}
          selectedValue={answer}
          onChange={onChange}
        />
      );
    case QUESTION_TYPES.text:
      return (
        <TextAnswer
          {...{ tempId }}
          selectedValue={answer}
          onChange={onChange}
        />
      );
    case QUESTION_TYPES.multiSelect:
      return (
        <PickList
          {...{ list }}
          name={`${tempId}[]`}
          selectedItems={answer}
          onChange={onChange}
        />
      );
    case QUESTION_TYPES.singleSelect:
      return (
        <SingleSelect
          name={tempId}
          {...{ list }}
          selectedValue={answer || null}
          onChange={onChange}
        />
      );
    case QUESTION_TYPES.scale: {
      const scaleDescription = get(settings, 'meta.scaleDescription', {});
      const scaleAnswers = getScaleAnswers(scaleDescription);

      return (
        <ScaleRange
          name={tempId}
          list={scaleAnswers}
          selectedItem={answer}
          onChange={onChange}
        />
      );
    }

    default:
      return null;
  }
};

Answers.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    settings: PropTypes.shape({
      name: PropTypes.string,
      displayableName: PropTypes.string,
      meta: PropTypes.object,
    }),
  }),
  answer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
  ]),
  surveyId: PropTypes.number,
  onChange: PropTypes.func,
};

Answers.defaultProps = {
  onChange: () => {},
};

export default Answers;



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Answers/index.jsx